import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import counter from "./counter";
import navigation from "./navigation";
import fuel from "./fuel";
import gas from "./gas";
import driving from "./driving";
import temp from "./temp";
import scan from "./scan";
import internationalization from "./internationalization";
import units from "./units";
import dates from "./dates";
import permissions from "./permissions";
import llantasPro from "./llantasPro";
import user from "./user";
import dashboard from "./dashboard";
export default combineReducers({
  routing: routerReducer,
  counter,
  navigation,
  fuel,
  gas,
  driving,
  temp,
  scan,
  llantasPro,
  internationalization,
  units,
  dates,
  permissions,
  user,
  dashboard
});



// WEBPACK FOOTER //
// ./src/modules/index.js